'use client';
import clsx from 'clsx';
import { AnalyticsProvider } from '../../lib/analytics';
import {
  SEGMENT_DEPLOYABLE_NAME,
  SEGMENT_DEPLOYABLE_VERSION,
  SEGMENT_WRITE_KEY,
} from '../../lib/analytics/constants';
import { SegmentAwareAnchor } from '../SegmentLink';
import { NwBadgeLogo } from '../Header/NWLogo/NwBadgeLogo';
import { NwTextLogo } from '../Header/NWLogo/NwTextLogo';

export function LogoOnlyHeader() {
  return (
    <AnalyticsProvider
      deployableName={SEGMENT_DEPLOYABLE_NAME}
      deployableVersion={SEGMENT_DEPLOYABLE_VERSION}
      writeKey={SEGMENT_WRITE_KEY}
    >
      <header className={clsx('satellite')}>
        <div
          className={clsx(
            'h-[var(--satellite-header-height)]',
            'min-h-[var(--satellite-header-height)]',
            'w-screen',
            'max-w-full',
            'w-full',
            'shadow-md',
            'flex',
            'flex-row',
            'items-center',
            'justify-center',
            'relative',
            'bg-white',
            'z-[900]',
          )}
        >
          <SegmentAwareAnchor
            segmentAttributes={{
              destination_url: '/',
              entity_name: 'global_nav_nw_logo',
              navigation_format: 'header',
            }}
            href="/"
            className={clsx('flex', 'justify-center', 'items-center', 'gap-2')}
            aria-label="Navigate to NerdWallet homepage"
          >
            <NwBadgeLogo className={clsx('h-5', 'lg:h-6', 'w-[27px]')} />
            <NwTextLogo
              className={clsx('h-[14px]', 'lg:h-[17px]', 'lg:w-[127px]', 'sm:block', 'hidden')}
            />
          </SegmentAwareAnchor>
        </div>
      </header>
    </AnalyticsProvider>
  );
}
